<template>
    <div class="login-container">
        <canvas height="640" width="100%" id="canvas" class="canvas"></canvas>
        <el-form
            ref="loginForm"
            :model="loginForm"
            :rules="loginRules"
            class="login-form cc"
            autocomplete="on"
            label-position="left"
        >
            <div class="title-container">教师联盟读书会</div>
            <el-form-item class="input-wrapper" prop="username">
                <span class="svg-container">
                    <svg-icon icon-class="user" />
                </span>
                <el-input
                    ref="username"
                    v-model="loginForm.user_name"
                    placeholder="用户名"
                    name="username"
                    type="text"
                    tabindex="1"
                    autocomplete="on"
                />
            </el-form-item>

            <el-tooltip v-model="capsTooltip" content="Caps lock is On" placement="right" manual>
                <el-form-item prop="password">
                    <span class="svg-container">
                        <svg-icon icon-class="password" />
                    </span>
                    <el-input
                        :key="passwordType"
                        ref="password"
                        v-model="loginForm.password"
                        :type="passwordType"
                        placeholder="密码"
                        name="password"
                        tabindex="2"
                        autocomplete="on"
                        @keyup.native="checkCapslock"
                        @blur="capsTooltip = false"
                        @keyup.enter.native="handleLogin"
                    />
                    <span class="show-pwd" @click="showPwd">
                        <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
                    </span>
                </el-form-item>
            </el-tooltip>

            

            

            <el-button
                :loading="loading"
                type="primary"
                style="width: 100%; margin-bottom: 30px"
                @click.native.prevent="handleLogin"
                class="login-button"
            >登录</el-button>
        </el-form>
        <div class="copyright">
            © 2023 教师联盟读书会
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { validUsername } from '@/utils/validate';
import { login } from '@/api/common.js';
import SlideVerify from '@/components/slideVerify';
import md5 from 'js-md5'

export default {
    name: 'login',
    data() {
        const validateUsername = (rule, value, callback) => {
            if (!validUsername(value)) {
                callback(new Error('请输入用户名'));
            } else {
                callback();
            }
        };
        const validatePassword = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入密码'));
            } else {
                callback();
            }
        };
        return {
            loginForm: {
                user_name: '',
                password: '',
                // username: 'admin',
                // password: 'Welcome1@admin',

                // username: 'accountadmin',
                // password: 'Welcome1@accountadmin',

                // username: 'auditadmin',
                // password: 'Welcome1@auditadmin',

            },
            loginRules: {
                user_name: [{ required: true, trigger: 'blur', validator: validateUsername }],
                password: [{ required: true, trigger: 'blur', validator: validatePassword }]
            },
            passwordType: 'password',
            capsTooltip: false,
            loading: false,
            redirect: undefined,
            otherQuery: {},
            codeUrl: '',
            isVerify: false
        };
    },
    watch: {
        $route: {
            handler: function (route) {
                const query = route.query;
                if (query) {
                    this.redirect = query.redirect;
                    this.otherQuery = this.getOtherQuery(query);
                }
            },
            immediate: true
        }
    },
    components: {
        SlideVerify
    },
    created() {
        // window.addEventListener('storage', this.afterQRScan)
    },
    computed: {
       
    },
    mounted() {
        // this.handleCanvas();
        if (this.loginForm.user_name === '') {
            this.$refs.username.focus();
        } else if (this.loginForm.password === '') {
            this.$refs.password.focus();
        }
        this.$store.commit('hideAuthExpires', false)
        // this.fetchVerifyCode()
        
    },
    destroyed() {
        // window.removeEventListener('storage', this.afterQRScan)
    },
    methods: {
        /**
         * 获取验证码
         */
        // fetchVerifyCode() {
        //     verifyCode().then(res => {
        //         const {path} = res.data;
        //         this.codeUrl = path
        //     })
        // },
        verifyError() {
            this.isVerify = false
        },
        verifySuccess() {
            this.isVerify = true
        },
        checkCapslock({ shiftKey, key } = {}) {
            if (key && key.length === 1) {
                // eslint-disable-next-line
                if ((shiftKey && key >= 'a' && key <= 'z') || (!shiftKey && key >= 'A' && key <= 'Z')) {
                    this.capsTooltip = true;
                } else {
                    this.capsTooltip = false;
                }
            }
            if (key === 'CapsLock' && this.capsTooltip === true) {
                this.capsTooltip = false;
            }
        },
        showPwd() {
            if (this.passwordType === 'password') {
                this.passwordType = '';
            } else {
                this.passwordType = 'password';
            }
            this.$nextTick(() => {
                this.$refs.password.focus();
            });
        },
        handleLogin() {

            this.$refs.loginForm.validate((valid) => {
                if (valid) {


                    this.loading = true;

                    login({
                        ...this.loginForm,
                        // password: md5(this.loginForm.password)
                    }).then((res) => {
                        this.loading = false;
                        this.$message.success('登录成功!');
                        this.$store.commit('updateToken', res.data);

                        this.$router.push('/group')
                        
                        // this.$store.commit('updateUserInfo', {
                        //     name: res.data.name,
                        // });
                        
                    }).catch(() => {
                        this.loading = false;
                    });
                } else {
                    return false;
                }
            });
        },
        
        getOtherQuery(query) {
            return Object.keys(query).reduce((acc, cur) => {
                if (cur !== 'redirect') {
                    acc[cur] = query[cur];
                }
                return acc;
            }, {});
        },
        handleCanvas() {
            var canvasEl = document.getElementById('canvas');
            var ctx = canvasEl.getContext('2d');
            var mousePos = [0, 0]; //鼠标位置

            var easingFactor = 5.0;
            var backgroundColor = '#2d3a4b';
            var nodeColor = '#20a0ff';
            var edgeColor = '#20a0ff';

            var nodes = [];
            var edges = [];

            canvasEl.width = document.body.clientWidth;
            canvasEl.height = document.body.clientHeight;

            function constructNodes() {
                //生成节点
                for (var i = 0; i < 55; i++) {
                    var node = {
                        drivenByMouse: i == 0,
                        x: Math.random() * canvasEl.width,
                        y: Math.random() * canvasEl.height,
                        vx: Math.random() * 1 - 0.5,
                        vy: Math.random() * 1 - 0.5,
                        radius: Math.random() > 0.9 ? 2 + Math.random() * 2 : 1 + Math.random() * 2
                    };

                    nodes.push(node);
                }

                nodes.forEach(function (e) {
                    nodes.forEach(function (e2) {
                        if (e == e2) {
                            return;
                        }

                        var edge = {
                            from: e,
                            to: e2
                        };

                        addEdge(edge);
                    });
                });
            }

            function addEdge(edge) {
                //添加链接线
                var ignore = false;

                edges.forEach(function (e) {
                    if (e.from == edge.from && e.to == edge.to) {
                        ignore = true;
                    }

                    if (e.to == edge.from && e.from == edge.to) {
                        ignore = true;
                    }
                });

                if (!ignore) {
                    edges.push(edge);
                }
            }

            function step() {
                nodes.forEach(function (e) {
                    if (e.drivenByMouse) {
                        return;
                    }

                    e.x += e.vx;
                    e.y += e.vy;

                    function clamp(min, max, value) {
                        if (value > max) {
                            return max;
                        } else if (value < min) {
                            return min;
                        } else {
                            return value;
                        }
                    }

                    if (e.x <= 0 || e.x >= canvasEl.width) {
                        e.vx *= -1;
                        e.x = clamp(0, canvasEl.width, e.x);
                    }

                    if (e.y <= 0 || e.y >= canvasEl.height) {
                        e.vy *= -1;
                        e.y = clamp(0, canvasEl.height, e.y);
                    }
                });

                adjustNodeDrivenByMouse();
                render();
                window.requestAnimationFrame(step);
            }

            function adjustNodeDrivenByMouse() {
                nodes[0].x += (mousePos[0] - nodes[0].x) / easingFactor;
                nodes[0].y += (mousePos[1] - nodes[0].y) / easingFactor;
            }

            function lengthOfEdge(edge) {
                //边框的长度
                return Math.sqrt(Math.pow(edge.from.x - edge.to.x, 2) + Math.pow(edge.from.y - edge.to.y, 2));
            }

            function render() {
                ctx.fillStyle = backgroundColor;
                ctx.fillRect(0, 0, canvasEl.width, canvasEl.height);

                edges.forEach(function (e) {
                    var l = lengthOfEdge(e);
                    var threshold = canvasEl.width / 4;

                    if (l > threshold) {
                        return;
                    }

                    ctx.strokeStyle = edgeColor;
                    ctx.lineWidth = (1.0 - l / threshold) * 2;
                    ctx.globalAlpha = 1.0 - l / threshold;
                    ctx.beginPath();
                    ctx.moveTo(e.from.x, e.from.y);
                    ctx.lineTo(e.to.x, e.to.y);
                    ctx.stroke();
                });
                ctx.globalAlpha = 1.0;

                nodes.forEach(function (e) {
                    if (e.drivenByMouse) {
                        return;
                    }

                    ctx.fillStyle = nodeColor;
                    ctx.beginPath();
                    ctx.arc(e.x, e.y, e.radius, 0, 2 * Math.PI);
                    ctx.fill();
                });
            }

            window.onresize = function () {
                canvasEl.width = document.body.clientWidth;
                canvasEl.height = document.body.clientHeight;

                if (nodes.length == 0) {
                    constructNodes();
                }

                render();
            };

            window.onmousemove = function (e) {
                mousePos[0] = e.clientX;
                mousePos[1] = e.clientY;
            };

            window.onresize(); // trigger the event manually.
            window.requestAnimationFrame(step);
        }
    }
};
</script>

<style lang="less">
.login-container {
    height: 100%;
    background: #2d3a4b;
    .el-form-item__error {
        left: 30px;
    }
}
.login-form {
    width: 400px;
    position: fixed;
    background: white;
    padding: 20px 30px 10px;
    border-radius: 4px;
    margin-top: -40px;
}
.title-container {
    font-family: '微软雅黑';
    font-size: 26px;
    font-weight: bold;
    margin-bottom: 20px;
    color: @primary-color;
    text-align: center;
}

.login-button {
    &:hover {
        color: white !important;
    }
}
.el-form-item__content {
    display: flex;
    position: relative;
}
.svg-container {
    margin-right: 16px;
}

.show-pwd {
    position: absolute;
    right: 6px;
    width: 40px;
    height: 40px;
    text-align: center;
}

.copyright {
    color: white;
    font-family: '微软雅黑';
    font-size: 12px;
    font-weight: bold;
    position: fixed;
    width: 100%;
    bottom: 22px;
    text-align: center;
}
.code-image {
    right: 6px;
    width: 80px;
    height: 28px;
    cursor: pointer;
}
</style>
